import httpManager from "@/app/shared/utils/httpManager";

class HubspotService {
  private url = "/hubspot";

  async loginHubspot() {
    const workspace = localStorage.getItem("workspace");
    const url = `${this.url}/login/?customer=${workspace}`;
    const response = await httpManager.get(url);

    return response.data;
  }

  async listContacts() {
    const workspace = localStorage.getItem("workspace");
    const url = `${this.url}/contacts/?customer=${workspace}`;
    const response = await httpManager.get(url);

    return response.data;
  }

  async importContacts() {
    const workspace = localStorage.getItem("workspace");
    const url = `${this.url}/contacts/import/?customer=${workspace}`;
    const response = await httpManager.post(url);

    return response.data;
  }
}

export const hubspotService = new HubspotService();
